import * as React from 'react'
import { NextSeo } from 'next-seo'

import { AboutTemplate, type AboutTemplateProps } from '@owl-nest/about-template'
import { SITE_URL } from '@boutique/config'

export type PageProps = { aboutPage: AboutTemplateProps['aboutPage'] }

export function Page({ aboutPage }: PageProps): React.ReactElement {
  return (
    <>
      <NextSeo
        title={aboutPage.title}
        description={aboutPage.title}
        openGraph={{
          title: aboutPage.title,
          description: aboutPage.title,
          images: [
            {
              alt: aboutPage.title,
              url: `${process.env.ASSET_PREFIX}/assets/images/Ulule_Boutique.png`,
            },
          ],
        }}
        additionalLinkTags={[
          {
            rel: 'icon',
            type: 'image/png',
            sizes: '48x48',
            href: SITE_URL + '/assets/images/favicon-48.png',
          },
          {
            rel: 'icon',
            type: 'image/png',
            sizes: '32x32',
            href: SITE_URL + '/assets/images/favicon-32.png',
          },
        ]}
      />
      <AboutTemplate locale="fr" aboutPage={aboutPage} />
    </>
  )
}
